import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Vuex from 'vuex'
import "./assets/css/main.css"
import "bootstrap/dist/css/bootstrap.min.css"
import VueTelInput from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueReCaptcha } from 'vue-recaptcha-v3'

const VueTelInputOptions = {
    mode: "international",
    onlyCountries: ["SG"],
    dropdownOptions: {
        disabled: true,
        showDialCodeInList: false
    },
    defaultCountry: "SG"
}

createApp(App).use(store).use(router).use(Vuex)
    .use(VueSweetalert2)
    .use(VueTelInput, VueTelInputOptions)
    .use(VueReCaptcha, { 
        siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
        loaderOptions: {
            autoHideBadge: true
        }
    })
    .mount('#app')

import "bootstrap/dist/js/bootstrap.js"